import React from 'react';
import { Download, Settings, CheckCircle, TrendingUp, Smartphone } from 'lucide-react';

export const HowItWorks = () => {
  const steps = [
    {
      icon: Smartphone,
      number: '01',
      title: 'Cek Versi Android Anda',
      description:
        'Buka Pengaturan → Tentang Ponsel → Versi Android. Jika Android 15+, install BAINSTALLER & Shizuku dulu',
    },
    {
      icon: Download,
      number: '02',
      title: 'Install BAiBOT inDriver',
      description:
        'Download dan install aplikasi BAiBOT inDriver di smartphone Android Anda',
    },
    {
      icon: Settings,
      number: '03',
      title: 'Aktifkan Izin Accessibility',
      description:
        'Berikan izin Accessibility Service agar BAiBOT dapat bekerja otomatis',
    },
    {
      icon: CheckCircle,
      number: '04',
      title: 'Atur Preferensi Anda',
      description:
        'Sesuaikan filter harga, area, jarak, dan pengaturan otomasi lainnya',
    },
    {
      icon: TrendingUp,
      number: '05',
      title: 'Biarkan BAiBOT Bekerja',
      description:
        'BAiBOT akan menangani pesanan secara otomatis dan meningkatkan penghasilan Anda',
    },
  ];

  return (
    <section
      id="how-it-works"
      style={{
        background: 'var(--bg-primary)',
        padding: '100px 7.6923%',
      }}
    >
      <div
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2
            style={{
              fontSize: '48px',
              fontWeight: 600,
              lineHeight: 1.1,
              letterSpacing: '-0.02em',
              color: 'var(--text-primary)',
              marginBottom: '16px',
            }}
          >
            Cara Kerja BAiBOT
          </h2>
          <p
            style={{
              fontSize: '20px',
              fontWeight: 500,
              lineHeight: 1.5,
              color: 'var(--text-secondary)',
            }}
          >
            Mulai otomasi dalam 5 langkah mudah
          </p>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '40px',
          }}
          className="steps-grid"
        >
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div
                key={index}
                style={{
                  position: 'relative',
                  textAlign: 'center',
                }}
              >
                <div
                  style={{
                    fontSize: '120px',
                    fontWeight: 600,
                    color: 'rgba(255, 255, 255, 0.05)',
                    lineHeight: 1,
                    marginBottom: '-40px',
                  }}
                >
                  {step.number}
                </div>
                <div
                  style={{
                    width: '80px',
                    height: '80px',
                    background: 'var(--brand-primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 24px',
                    transition: 'all 0.4s ease-in-out',
                  }}
                  className="dark-hover"
                >
                  <Icon size={36} color="#000000" />
                </div>
                <h3
                  style={{
                    fontSize: '24px',
                    fontWeight: 600,
                    lineHeight: 1.3,
                    color: 'var(--text-primary)',
                    marginBottom: '12px',
                  }}
                >
                  {step.title}
                </h3>
                <p
                  style={{
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: 1.4,
                    color: 'var(--text-secondary)',
                  }}
                >
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
      <style>
        {`
          @media (max-width: 767px) {
            .steps-grid {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
    </section>
  );
};